import { useParams } from 'react-router'
import { ContactRecord } from './contact/ContactRecord'

/**
 * /relaties/contacten/:personId (spec-63 E3, design §4.5). Another person is another
 * page: nothing of the previous one (data, a half-typed draft, an open dialog) carries over.
 */
export function ContactDetailPage() {
  const { personId = '' } = useParams()
  return <ContactRecord key={personId} personId={personId} />
}
